export enum DefaultProjectTemplateEnum {
    Accounts_Payable = '2ea61856-8c31-4975-85e9-3a72a9ee16dc',
    Accounts_Receivable = 'c9f7b209-dfb7-4bb4-bb37-781c1a9abc9a',
    All_Hands_Meeting = '72ccc11d-35ae-419c-981f-3e5f526c71e8',
    Architecture_Design = '6e0bff13-83ac-486c-a309-c707bf82bcc4',
    Backlogs_And_Sprints = 'cbdcc448-b212-4832-9d07-9a8f5a051d99',
    Branding = '5c1495e9-a00b-4548-b119-cd10096a9f66',
    Bug_and_Issue_Tracking = '050d82a3-c543-4939-9415-6b0c2c33053a',
    Candidate_Database = 'ead2c075-8c88-4ce0-a9fb-c2e3cff2403b',
    Case_Management = 'f088ccfb-18e9-4a10-b432-c2623ed9b614',
    Client_Inquiries = '99c4477f-73f2-4c27-be2f-5d8eb9eefc10',
    Client_HR_Requirements = '99c4477f-73f2-4c27-be2f-5d8eb9eefc10',
    Construction_Roadmap = 'e248cfed-910d-479f-b8ff-7dd64518c68f',
    Corporate_Audit = 'e2c96278-0e83-409f-8116-4395f027c38',
    Creative_Requests = '406a189c-00be-49ca-8ae6-6fe7961003d4',
    Customer_Account_Management = '27aabb3d-f0f5-4777-9045-e8a230fc91a3',
    Customer_Onboarding = '2843a6cc-402e-43f4-a11e-eb8cbb8fd273',
    Customer_Support_Tickets = '4b07c2de-6841-4647-ba58-5ee285d3e51c',
    Deal_Pipeline = '22a53217-8f63-4858-b5bb-e0f283c62811',
    Email_Marketing_Calendar = 'bf26eadf-4e96-436d-ab09-62f4771dd8e2',
    Employee_Database = '50f30908-864b-46d1-85fd-10876c702381',
    Employee_Onboarding = 'da87294a-f6f6-4a17-bb6b-79772f279b72',
    Employee_Training_Management = '7899676e-8f99-476b-bdd8-3f9cc977696e',
    Event_Management = '8446da80-c80c-4198-9586-a25958dad47f',
    Event_Vendors = '2562a023-43ad-4632-8bc9-37f1088abd65',
    Event_Venues = 'd86c01c7-1e9c-472b-9fa5-b5cd007b56eb',
    Expense_Tracking = '67f7dca8-a58a-4821-8a28-45205b472918',
    Feature_Development= '29ccf830-41e8-4072-a750-a44bc8fa62d2',
    Feature_Requests = 'b8447ec6-4b11-4215-800b-75f8db5bc465',
    Fund_Raising = '86ba37a4-0b1c-49aa-8ff0-00cd376e7c59',
    Guest_Management = '2fd48c62-1256-46b9-a465-22335586d187',
    Grants_Projects = '5319474f-a875-46b0-a8b3-b0bd0db22b14',
    GST_Filing = '9a72bfb5-37d2-4dc6-a081-c7e0144a6f00',
    Hiring = '4d7445f6d-221c-4d29-b862-f3c036ad12b3',
    
    Interior_Design = 'e6bc4695-f5fd-4e9e-8098-c8e2a82c195c',
    Investors_Database = 'a9066971-0889-4549-b3c3-58a629361dc0',
    IT_Support_Ticket = 'bf678f59-5901-4652-ab34-187e13922d6a',
    Itinerary_Approval = 'adf9a2fa-f597-47de-88eb-8bd2e60b8466',
    Lead_Tracking = 'c41f736b-a7bf-4d2c-8fc6-f9710f873c66',
    Legal_Agreement_Management = '1b7f7550-4fa8-4805-a571-fb907d72cc11',
    LMS_Tracking_Course = '580dd678-3f70-4cc2-ba7d-86ea926ea8c8',
    Long_Video = 'e2a83d00-fff7-43fc-bc14-31bafaefc053',
    Machine_Manufacturing = '105d9be0-74bf-44bb-bee8-21ae67510e62',
    Marketing_Campaign = 'bd963062-6532-46f0-a57b-b90241546940',
    Order_Tracker = '14e43f03-aaed-4d91-83d3-8370360cf9d0',
    New_Product_Development = '6139b84f-9b9e-4de8-a79f-03126c99b691',
    Partners = '6d993efd-db1a-43e5-94c4-4e0cb1c71137',
    Primary_Research_Plan = '71e6d4e7-0828-4356-be8f-f993f11e236b',
    Procurement = '4e302f7c-0029-4684-aa98-d16781ba0b2b',
    Properties_for_Lease = '4a9fde0a-04be-4242-9312-2a2bc81c5a27c',
    Properties_for_Selling = '2b767d77-e608-4fac-8b4e-809904e6adbd',
    
    Real_Estate_CRM = '5a8755c2-87ac-49ca-b578-8937a4426acc',
    Real_Estate_Management = 'a161e904-670f-4150-a97f-90b3bf2010c1',
    Rebranding = '14e013c6-240d-4a34-a6d0-829da51b911d',
    SEO_Ongoing_Work = '3977f4ea-9e0d-4c03-b10c-ab0b668fff11',
    Short_Video = 'b88ee4d1-c013-4940-8871-21e5391f9bc6',
    Site_Tracking = 'ede71859-6f54-4aba-94cf-fe602ce133b4',
    Social_Media_Analytics = 'e9129321-0d61-48e2-bb50-06b18328242e',
    Social_Media_Calendar = 'fee9a482-90f2-4776-b2eb-7d73d20f5c3b',
    Solar_Project = 'df121f82-5425-4e6a-a4e6-0e2f3646a692',
    Student_Tracking = '32ff05a0-5e32-4d98-b5f3-a1c7e9c08bcc',
    Trip_and_Package_Name = '2ecd2cd3-03c4-47b0-9b31-d04fb90ef7b1',
    Website_Content_Calendar = 'e099d5c8-6093-4143-9800-8a51511cb358',
    Website_Design = '81293b08-3069-4ecb-9188-c5ffd7e1719d',
    Website_Page_Production = '65ea30cf-8786-4728-8576-10183f4ba04f',    
}
